/* eslint-disable */
import * as THREE from 'three'
import r1 from './r1.js'
import c11 from './c11.js'

var r = function (e) {
  function r(e, t, n) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, r);
    var i = function (e, t) {
      if (!e)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t
    }(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e, t));
    return i.options = (0,
      c11.merge)({
        amplitude: 50,
        depth: 1,
        ox: 0,
        oy: 0
      }, n),
      i.oPosition = {
        x: i.options.ox,
        y: i.options.oy
      },
      i
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(r, THREE.Mesh),
    r1(r, [{
      key: "parallax",
      value: function (e) {
        var t = !(1 < arguments.length && void 0 !== arguments[1]) || arguments[1];
        this.position.x = (this.oPosition.x + this.options.amplitude * e.x / this.options.depth).toFixed(2),
          this.position.y = t ? (this.oPosition.y + this.options.amplitude * e.y / this.options.depth).toFixed(2) : this.oPosition.y.toFixed(2)
      }
    }, {
      key: "resize",
      value: function (e) {
        this.oPosition.x = this.options.ox * e,
          this.oPosition.y = this.options.oy * e,
          this.scale.x = this.scale.y = e
      }
    }, {
      key: "dispose",
      value: function () {
        this.options = null,
          this.oPosition = null
      }
    }]),
    r
}();
var t = { default: r }

export default t
